import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  connect() {
    this.apply(localStorage.getItem("theme") || "light")
    this.bound = () => this.apply(localStorage.getItem("theme") || "light")
    document.addEventListener("turbo:render", this.bound)
  }
  disconnect() { document.removeEventListener("turbo:render", this.bound) }
  toggle() {
    const next = localStorage.getItem("theme") === "dark" ? "light" : "dark"
    localStorage.setItem("theme", next)
    this.apply(next)
  }
  apply(t) { document.documentElement.classList.toggle("dark", t === "dark") }
}
